import {useState} from "react";
import Design1 from "./design-1";
import './index.css';

export const setCookie = (name, value, days = 30) => {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/`;
};

export const getCookie = (name) => {
    const prefix = name + "=";
    const ca = document.cookie.split(";");
    for (let c of ca) {
        c = c.trim();
        if (c.startsWith(prefix)) {
            return decodeURIComponent(c.substring(prefix.length));
        }
    }
    return "";
};

export default function PopupBlock(props) {
    const [dismissedIds, setDismissedIds] = useState(new Set());

    // Find the first popup that is active and not yet dismissed
    const nextPopup = props?.popups?.find((p) => {
        if (!p?.content?.isActive) return false;
        return !dismissedIds.has(p?.content.modalId);

    })?.content;
    
    const handleDismiss = (id) => {
        setDismissedIds((prev) => new Set(prev).add(id));
    };

    if (!nextPopup) return null;

    switch (props.settings?.design) {
        case 0 :
            return (<Design1 {...nextPopup} onClose={() => handleDismiss(nextPopup.modalId)}/>);
        default:
            return (<Design1 {...nextPopup} onClose={() => handleDismiss(nextPopup.modalId)}/>);
    }
}
